const B_1 = [
    {
        title: '项目流程',
        path: '/revision/liucheng/index'
    }
]

export default {
    path: 'index',
    component: () => import(/*webpackChunkName: 'revision-liucheng'*/'@layout/empty'),
    children: [
        {
            path:"",
            component: () => import(/*webpackChunkName: 'revision-liucheng'*/'@views/bidding/views/project-revision/liucheng/index'),
            meta: {
                title: '项目流程',
                bread: B_1
            },
        }
    ]
}
